// CSRF トークン取得の共通実装 (web/ts 内で唯一の実装。個別実装を追加しないこと)。
//
// サーバ側 (internal/auth/csrf.go) はダブルサブミットクッキー方式で、
// cookie "csrf_token" が唯一の「正」の取得源:
//   - EnsureCSRFToken は cookie の現在値をそのまま返すだけで、meta タグ
//     (templates/layouts/base.html) やフォームの hidden input "_csrf" は
//     レンダリング時点の cookie 値のコピーにすぎない。
//   - 検証 (auth.VerifyCSRF / handler.verifyCSRFHeader) は送信値を
//     受信した csrf_token cookie 群と照合する。ページ描画後に cookie が
//     作り直されると meta / hidden は古くなるが、cookie 値を送れば必ず一致する。
//   - 同名 csrf_token cookie が複数本残る環境 (旧 Path/Domain の残骸) でも、
//     document.cookie に見える値は必ず送信対象なので先頭 1 本で足りる
//     (サーバは全 cookie を照合する)。
//
// よって優先順は cookie → meta → hidden input。meta / hidden は
// cookie が読めない異常系 (cookie ブロック等) の保険として残す。

/** CSRF トークンを cookie → meta → hidden input の優先順で取得する。 */
export function csrfToken(): string {
  const m = document.cookie.match(/(?:^|; )csrf_token=([^;]*)/);
  if (m) return decodeURIComponent(m[1]);
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  if (meta && meta.content) return meta.content;
  const inp = document.querySelector<HTMLInputElement>('input[name="_csrf"]');
  return inp ? inp.value : "";
}
